module.exports = __webpack_public_path__ + "static/media/quarrytruck1_preview.af57744d.jpg";